import api from './utilPartner';

const controller = 'PropostaResultadoScript';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: function (dto) {
    return api.Axios.GetParams(`${url}/Listar`, dto);
  }
});
